import styled from "styled-components";
import { InternalLink } from "../../links/InternalLink";
import { ExternalLink } from "../../links/ExternalLink";
import { Device } from "../../../styles/screenSizes";

export const StyledNavigationLinks = styled.div`
  min-width: 120px;
  font-size: 1rem;

  @media ${Device.mobile} {
    min-width: 100%;
  }

  @media ${Device.tablet} {
    min-width: 50%;
  }

  @media ${Device.laptop} {
    display: flex;
    justify-content: flex-end;
  }
`;

export const StyledCategoryName = styled.div`
  text-transform: uppercase;
  font-size: 1rem;
  font-weight: bold;
  padding-bottom: 0.25rem;
`;

export const StyledNavigationList = styled.div`
  display: flex;
  flex-direction: column;
  /* We need it so we can have line breaks with \n */
  white-space: pre;

  > :not(:first-child) {
    padding-top: 20px;
  }
`;

export const StyledExternalLink = styled(ExternalLink)`
  font-size: 1rem;

  @media ${Device.mobile} {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const StyledInternalLink = styled(InternalLink)`
  font-size: 1rem;

  @media ${Device.mobile} {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
